import { ObjectValues } from "types";

const QuestionSearchTextType = {
  QUESTIONS: "questions",
  ANSWERS: "answers",
  TAGS: "tags",
  TRANSLATIONS: "translations",
} as const;

export type QuestionSearchTextTypeTerm = ObjectValues<typeof QuestionSearchTextType>;

export default QuestionSearchTextType;
